'use client';

/**
 * RichTextBlock — rendu du HTML produit par TipTap.
 * Trois largeurs : narrow (CGV/legal), medium, wide.
 */
export default function RichTextBlock({ config }) {
  const html = config.html || '';
  const maxWidth = {
    narrow: '720px',
    medium: '900px',
    wide: '1200px',
  }[config.max_width] || '900px';

  return (
    <section style={{ padding: '36px 0' }}>
      <div
        className="container-page rich-text-content"
        style={{ maxWidth }}
        dangerouslySetInnerHTML={{ __html: html }}
      />
    </section>
  );
}
